import { FC } from 'react';
import { Modal, Table } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}
const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return '';
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const month = date.getMonth() + 1; // No padding with zeros
        const day = date.getDate(); // No padding with zeros
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return '';
    }
};

export const ReconiliAddress: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">GRN Information</h1>
                    </div>

                    {/* Table 1: Supplied WT, Received WT, Gain/Loss */}
                    <div className="mb-10">
                        <h3 className="mb-5">Weight </h3>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Supplied WT</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}> Received WT</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Gain/Loss</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.totalQuantity || 'N/A'} Kg</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.recQuantity || 'N/A'} Kg</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.weightMeasurementType || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Table 2: Instruction, Amount, Document */}
                    <div className="mb-10">
                        <h3 className="mb-5">Instruction Details</h3>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Instruction</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Amount (INR)</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Document</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.note?.[0]?.noteType || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.note?.[0]?.price || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.grnDetails?.note?.[0]?.images?.map((pdfUrl: string, index: number) => (
                                            <i
                                                key={index}
                                                className="bi bi-file-pdf text-danger cursor-pointer"
                                                style={{ fontSize: '3rem' }}
                                                onClick={() => window.open(pdfUrl, '_blank')}
                                                title="View PDF"
                                            ></i>
                                        )) || 'N/A'}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Table 3: Quality Assessment */}
                    <div className="mb-10">
                        {/* <h3 className="mb-5">Quality Assessment</h3> */}
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Quality Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.grnDetails?.qualityRemarks?.[0] || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>












                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontFamily: 'Arial, sans-serif'
                    }}>
                        <tbody>
                            <tr>
                                <td style={{
                                    padding: '12px',
                                    textAlign: 'center'
                                }}>
                                    {user?.grnDetails?.note[0]?.images[0] && (
                                        <img
                                            src={user.grnDetails.note[0].images[0]}
                                            alt="Note Image"
                                            style={{
                                                // border: "2px solid red",
                                                maxWidth: '200px',
                                                maxHeight: '150px',
                                                // border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    )}
                                </td>
                                <td style={{
                                    padding: '12px',
                                    textAlign: 'center'
                                }}>
                                    {user?.grnDetails?.grnImages[0]?.docUrl && (
                                        <img
                                            src={user.grnDetails.grnImages[0].docUrl}
                                            alt="GRN Image"
                                            style={{
                                                maxWidth: '200px',
                                                maxHeight: '150px',
                                                // border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>









                    {/* Table 4: QA Images */}
                    <div className="mb-10">
                        <h3 className="mb-5">QA Images</h3>
                        <div className="d-flex flex-wrap">
                            {user?.qaImages?.map((image: string, index: number) => (
                                <div key={index} className="m-2">
                                    <img
                                        src={image}
                                        alt={`QA Image ${index + 1}`}
                                        style={{ maxWidth: '200px', maxHeight: '200px' }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* GRN Date */}
                    <div className="mb-10">
                        <h3 className="mb-5">GRN Date</h3>
                        <p>{formatDateForInput(user?.createdAt) || 'N/A'}</p>
                    </div>




                    <div className="mb-10">
                        <h3 className="mb-5">Instruction Details</h3>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginBottom: '20px',
                                tableLayout: 'fixed' // This helps maintain consistent column widths
                            }}>
                            <thead style={{ backgroundColor: '#BFD7ED' }}>
                                <tr>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Decision</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Final Amount (INR)</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Reconciliation Done</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.reconciliationDetails?.decision}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.reconciliationDetails?.price}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        {user?.reconciliationDetails?.createdAt
                                            ? new Date(user.reconciliationDetails.createdAt).toLocaleDateString('en-GB')
                                            : 'N/A'}
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>





                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};